import React from 'react'
import { Button, ButtonProps } from '../../components/Button/Button'
import { TrackEvent, useTracking } from '../../apps/professional-app/fa/common/tracking'
import { useAppSelector } from '../../store/hooks'
import { selectAccountId } from '../../store/auth/authSlice'
import { useCreateCustomerPortalSessionMutation, useGetBillingCustomerQuery } from '../../store/plan/plan'

export const ChangePaymentInfoButton: React.FC<ButtonProps> = (props) => {
  const { tracked } = useTracking()
  const accountId = useAppSelector(selectAccountId)
  const { data: customer } = useGetBillingCustomerQuery({ accountId })
  const [openCustomerPortalSession] = useCreateCustomerPortalSessionMutation()

  const handleBillingHistoryClick = tracked(
    async () => {
      const response = await openCustomerPortalSession({
        accountId,
      }).unwrap()
      if (response.data.url) {
        window.location.href = response.data.url
      }
    },
    { eventName: TrackEvent.PLAN_BILLING_HISTORY_OPENED },
  )

  return (
    <Button variant='primary' {...props} onClick={() => handleBillingHistoryClick()}>
      {customer?.data.hasPaymentMethod ? 'Change Payment Info' : 'Enter Payment Information'}
    </Button>
  )
}
